/**
 * Created by lihanying on 2017/7/14.
 */
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as actions from './action'
import Member from './component/editableTable'
import { Spin } from 'antd'

class ClubMemberList extends React.Component {
  static defaultProps = {
    walletInfo: [],
  }
  state = {
    loading: true,
  }

  componentDidMount() {
    this.props.fetchWalletInfo().then((res) => {
      this.setState({ loading: false })
    })
  }

  render() {
    const { walletInfo } = this.props
    return (
      <div>
        {this.state.loading ? (
          <Spin
            tip="正在加载..."
            className="level-loading"
            style={{ textAlign: 'center' }}
          />
        ) : (
          <Member
            walletInfo={walletInfo}
            fetchAddClubMember={this.props.fetchAddClubMember}
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    walletInfo: state.getClubMember.walletInfo,
  }
}
export default withRouter(connect(mapStateToProps, actions)(ClubMemberList))



// WEBPACK FOOTER //
// ./src/containers/ClubMember/index.js